"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClockForwardOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.clock-forward_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "clock-forward_outline_svg__transparent_box" },
            React.createElement("path", { className: "clock-forward_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "clock-forward_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "clock-forward_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M14.99 15.58l-3.7 3.72 1.42 1.4 4.28-4.3L17 10h-2l-.01 5.58z" }),
            React.createElement("path", { d: "M23.43 16L22 17.4l4.95 5 5-5L30.5 16 28 18.47V16a12 12 0 10-5.46 10.06l-1.09-1.68A10 10 0 1126 16v2.57z" }))));
}
exports.default = SvgClockForwardOutline;
//# sourceMappingURL=ClockForwardOutline.js.map